import { Alert, Box, Typography, useTheme } from '@mui/material';
import { Theme } from '@mui/material/styles';

import { Icon } from '@/components/Icon/Icon';
import { PageWithRightImage } from '@/components/Layout/Page/PageWithRightImage.tsx';
import { ReviewPersonalDetails } from '@/components/PageForm/PersonalDetails/Review/ReviewPersonalDetails';

import { useResponsive } from '@/hooks/useResponsive.ts';
import { useTranslate } from '@/hooks/useTranslate';

import { getAPIErrorMessage } from '@/utils/api';

import { useReviewPersonalDetails } from './hooks/useReviewPersonalDetails';

export default function ReviewPersonalDetailsPage() {
  const { t } = useTranslate();
  const theme = useTheme();
  const { isMobile } = useResponsive();
  const {
    user,
    isUserInfoComplete,
    isPending: isConfirmPending,
    error,
    onContinue,
    onUpdate,
  } = useReviewPersonalDetails();

  if (!user) return null;

  const pageTitle = t('remediation.reviewPersonalDetails.title');

  return (
    <PageWithRightImage
      loading={isConfirmPending}
      bgColor={theme => theme.palette.neutral[100]}
      headerMobile={{
        leftSlot: null,
        centerSlot: (
          <Typography variant="headlineH5" textAlign="center">
            {pageTitle}
          </Typography>
        ),
        bgColor: (theme: Theme) => theme.palette.neutral[100],
      }}
    >
      <Box sx={{ paddingBottom: { xs: 4, lg: 0 } }}>
        {!isMobile && (
          <Typography variant="headlineH2" mb={1}>
            {pageTitle}
          </Typography>
        )}
        <Typography
          variant={isMobile ? 'bodyB2Regular' : 'bodyB1Regular'}
          textAlign={{ xs: 'center', lg: 'left' }}
          color={theme.palette.neutral[800]}
          mb={{ xs: 2, lg: 3 }}
          mt={{ xs: 1, lg: 3 }}
          mr={{ xs: 0, lg: 10 }}
        >
          {t(
            'moreInfo.reviewPersonalInfo.drawer.reviewPersonalInfo.description',
          )}
        </Typography>
        {error && (
          <Box my={1.5} width="100%">
            <Alert
              icon={<Icon name="alert" />}
              color="error"
              variant="standard"
            >
              {getAPIErrorMessage(error)}
            </Alert>
          </Box>
        )}
        <ReviewPersonalDetails
          onContinue={onContinue}
          onUpdate={onUpdate}
          user={user}
          isUserInfoComplete={isUserInfoComplete}
          confirmCheckboxVisible
          continueButtonLabel={t('common.confirm')}
        />
      </Box>
    </PageWithRightImage>
  );
}
